// extracted by mini-css-extract-plugin
module.exports = {"inPlayIcon":"_7f84c4f","inPlayBlink":"_775ae5c"};